module.exports = __webpack_public_path__ + "media/בול.b0a04e73.mp3";